import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { SetDashboardModalOpen } from 'src/app/core/state/dashboard-plugins.actions';
import { IDocumentOnNode } from 'src/app/document-user/models/document.model';
import { getLinkToDocument } from 'src/app/document-user/functions/get-link-to-document';

@Component({
  selector: 'app-document-read-receipts-dashboard-modal',
  templateUrl: './document-read-receipts-dashboard-modal.component.html',
  styleUrls: ['./document-read-receipts-dashboard-modal.component.scss'],
  standalone: false,
})
export class DocumentReadReceiptsDashboardModalComponent implements OnInit, OnDestroy {
  displayedColumns = ['name', 'menuName'];
  disabledColumnHeaders = ['name', 'menuName'];
  columnTitlesMap = {
    name: 'document',
    menuName: 'placement',
  };

  constructor(
    public dialogRef: MatDialogRef<DocumentReadReceiptsDashboardModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { items: IDocumentOnNode[] },
    private router: Router,
    private store: Store
  ) {}

  ngOnInit(): void {
    this.store.dispatch(new SetDashboardModalOpen(true));
  }

  ngOnDestroy(): void {
    this.store.dispatch(new SetDashboardModalOpen(false));
  }

  navigateToDocument(document: IDocumentOnNode): void {
    const { link, referrerType } = getLinkToDocument(document);
    this.router.navigate([link], { queryParams: { referrerType } });
    this.dialogRef.close();
  }
}
